import gql from 'graphql-tag';

export default gql`
  mutation changeCollegeEventStatus($input: changeCollegeEventStatusInput!) {
    changeCollegeEventStatus(input: $input) {
      collegeEvent {
        id
        name
        version
        status
      }
    }
  }
`;
